import { RefreshIcon } from "src/foundations/icons";
import { useTimeData } from "src/components/monitoring/senec-time-frame-selection/TimeFrameContext";
import { TimeRange } from "src/components/monitoring/commonTypes";
import { getLatestTimeFrame } from "src/components/monitoring/senec-time-frame-selection/timeFrameUtils";
import {
    SenecFunctionalIconButton,
    SenecFunctionalIconButtonProps,
} from "src/components/button/senec-functional-button/SenecFunctionalIconButton";

export interface SenecTimeFrameRefreshProps extends SenecFunctionalIconButtonProps {
    disableFuture?: boolean;
}

export const SenecTimeFrameRefresh = (props: SenecTimeFrameRefreshProps) => {
    const { timeRange, onTimeFrameChange } = useTimeData();

    const refreshTimeFrame = () => {
        if (timeRange !== TimeRange.FREE && timeRange !== TimeRange.CUSTOM) {
            onTimeFrameChange(getLatestTimeFrame(timeRange, props.disableFuture)!);
        }
    };

    return (
        <SenecFunctionalIconButton
            data-testid="time-frame-refresh-button"
            level="secondary"
            {...props}
            disabled={props.disabled ?? (timeRange === TimeRange.FREE || timeRange === TimeRange.CUSTOM)}
            onClick={(event) => {
                refreshTimeFrame();
                if (props.onClick) props.onClick(event);
            }}
        >
            <RefreshIcon />
        </SenecFunctionalIconButton>
    );
};
